import {createAction, createReducer} from '@reduxjs/toolkit';

interface NotificationState {
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'info' | 'warning';
}

const initialState: NotificationState = {
    open: false,
    message: '',
    severity: 'info',
};

export const showNotification = createAction<{
    message: string;
    severity?: 'success' | 'error' | 'info' | 'warning'
}>('notification/show');
export const hideNotification = createAction('notification/hide');

const notificationReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(showNotification, (state, action) => {
            state.open = true;
            state.message = action.payload.message;
            state.severity = action.payload.severity || 'info';
        })
        .addCase(hideNotification, (state) => {
            state.open = false;
        });
});

export default notificationReducer;
